import React from 'react';
import { useImpersonation } from '@hooks/useImpersonation';
import { useAuthContext } from '@contexts/AuthContext';
import { useLanguage } from '@contexts/LanguageContext';
import Button from '@components/common/Button';
import Icon from '@components/Icon/Icon';
import './ImpersonationBanner.scss';

const ImpersonationBanner = () => {
  const { user } = useAuthContext();
  const { is_impersonating, endImpersonation, loading } = useImpersonation();
  const { t } = useLanguage();

  // N'afficher que si en cours d'impersonation
  if (!is_impersonating) {
    return null;
  }

  return (
    <div className="impersonation-banner">
      <div className="impersonation-banner__content">
        <Icon icon="exchange-alt" className="impersonation-banner__icon" />
        <div className="impersonation-banner__text">
          <strong>🎭 {t('admin.impersonation.banner.title', { userName: user?.name })}</strong>
          <span>{t('admin.impersonation.banner.subtitle')}</span>
        </div>
      </div>
      <div className="impersonation-banner__actions">
        <Button
          variant="secondary"
          size="small"
          onClick={endImpersonation}
          loading={loading}
        >
          {t('admin.impersonation.banner.end_button')}
        </Button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
